<template>
  <!-- 
    sometimes, we want to prevent the button from being clicked e.g. if a payment is being processed, then we dont
    want the user to be able to click the other buttons while it is being processed.
  -->
  <div
    :class="[{ 'button-disabled': isDisabled}, { 'disabled': isProcessing }]"
    @click="emitClick"
    @keydown.enter.prevent="emitEnter"
  >
    <!-- sometimes we don't want a spinner, in this case, set showSpinner to false -->
    <div v-if="showSpinner && isProcessing" class="spinner-padding">
      <Spinner />
    </div>
    <div :class="[{'hidden' : showSpinner && isProcessing}]">
      <slot />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Spinner from '@/components/utilComponents/Spinner';

export default Vue.extend({
  name: 'SpinnerButton',
  components: {
    Spinner
  },
  props: {
    isProcessing: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    showSpinner: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    emitClick() {
      this.$emit('click');
    },
    emitEnter() {
      this.$emit('enter');
    }
  }
})
</script>

<style scoped lang="scss">
.button-disabled {
  color: $dim-gray;
  background-color: $light-gray!important;
  box-shadow: 0 1px 1px 1px $bright-gray!important;
  pointer-events: none;
}

.disabled {
  pointer-events: none;
}

.spinner-padding {
  position: absolute;
}

.hidden {
  visibility: hidden;
}
</style>